import type { LucideIcon } from 'lucide-react';
import { Link } from '@tanstack/react-router';
import styles from './EmptyState.module.css';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
  actionIcon?: LucideIcon;
}

export function EmptyState({ icon: Icon, title, description, actionLabel, actionTo, actionIcon: ActionIcon }: EmptyStateProps) {
  return (
    <div className={styles.container}>
      <div className={styles.iconCircle}>
        <Icon size={36} strokeWidth={1.5} />
      </div>
      <div className={styles.title}>{title}</div>
      {description && <div className={styles.description}>{description}</div>}
      {actionLabel && actionTo && (
        <Link to={actionTo} className={styles.cta}>
          {ActionIcon && <ActionIcon size={14} strokeWidth={2} />}
          {actionLabel}
        </Link>
      )}
    </div>
  );
}
